export default function() {
    return {
        username: '',
        password: '',
        loginError: ''
    }
}
